import { ShipmentLocationTypeIdType } from './shipment-location-type-id';

export interface EntityId {
  entityId: number;
  entityTypeId?: ShipmentLocationTypeIdType;
}
